import { SharedState } from '@trello/shared-state';
import type {
  AjaxEvent,
  RpcEvent,
  SocketRpcEvent,
} from 'app/scripts/network/rpc/logConnectionInformation';

type ConnectionEvent = AjaxEvent | RpcEvent | SocketRpcEvent;

export const connectionInformationState = new SharedState<{
  eventLog: ConnectionEvent[];
  eventLogLimit: number;
}>({
  eventLog: [],
  eventLogLimit: 200,
});
